import React from 'react';
import { PropTypes } from 'prop-types';
import { usePropertyViewsModal } from '@molecules/PropertyViewsModal';
import { ButtonNoStyles } from '@styled';
import styled from 'styled-components';
import colors from '@general/colors';

const StyledButton = styled(ButtonNoStyles)`
    font-size: 12px;
    text-decoration: underline;
    color: ${colors.azure};
`;

const PropertyViewsLink = ({ isLoggedIn = true, uniqueViews }) => {
    const { openModal: openPropertyViewsModal } = usePropertyViewsModal();

    const openModal = () => {
        openPropertyViewsModal({
            uniqueViews,
        });
    };

    if (!isLoggedIn || !uniqueViews) {
        return null;
    }

    return (
        <StyledButton
            type="button"
            onClick={() => openModal()}
            onKeyDown={e => {
                if (e.key === 'Enter') {
                    openModal();
                }
            }}
        >
            Total Users (unique viewers): {uniqueViews.length}
        </StyledButton>
    );
};

PropertyViewsLink.propTypes = {
    isLoggedIn: PropTypes.bool,
    uniqueViews: PropTypes.array,
};

export default PropertyViewsLink;
